import {atom} from 'jotai';

/**
 * Controls the global BuyCreditsModal. Set true to open it from anywhere (the
 * credits view button, or when a Pro user is blocked by running out of credits).
 * The modal is mounted once per top-level layout.
 */
export const buyCreditsOpenAtom = atom(false);
